<template>
  <div class="module_page page_content institution" aria-label="Institution Summary view content page">
    <div class="row page-heading" v-if="isSuperAdmin">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-4 btn_container text-right" v-if="isSuperAdmin && !editMappingMode">
        <button type="button" class="btn btn-primary" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">delete</button>
        <b-btn @click="setEditMappingMode">add mapping</b-btn>
      </div>
      <div class="col-4 btn_container text-right" v-if="isSuperAdmin && editMappingMode">
        <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="delete">cancel</button>
        <b-btn @click="save">save</b-btn>
      </div>

    </div>
    <div class="page_content_container">
      <institution-menu :uuid="uuid" :active="'institutionEmployerMapping'"></institution-menu>
      <div class="row pg_content">
		    <div class="col-12">
          <div class="course-management-section" v-if="!editMappingMode">
            <div class="page_subheading">
              <div class="col-5" style="padding-left: 0px;">
              </div>
              <div class="col-7 btn_container pagination_sty3">
                <button type="button" :disabled="this.firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
                  <option v-for="option in sizeOptions" v-bind:value="option">
                  {{ option }}
                  </option>
                </select>
              
                <button type="button" :disabled="this.lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button></div>
            </div>

            <div class="course-management-table-container">
              <table class="table b-table table-bordered border">
                <thead class="thead-light text-center">
                  <tr>
                    <th class="first-column" v-if="isSuperAdmin">
                      <label class="form-checkbox">
                        <input type="checkbox" v-model="selectAll" @click="select" :disabled="(institution.institutionEmployerMapping.length === 0) || permission.systemPermission.readOnly" aria-label="select all configs">
                        <i class="form-icon"></i>
                      </label>
                    </th>
                    <th class="second-column">Employer</th>
                    <th class="third-column">Status</th>
                    <th class="third-column">Spotlight</th>
                    <th class="fourth-column">Updated By</th>
                    <th class="fourth-column">Updated At</th>
                    <th class="fourth-column">Job Posted</th>
                    <th class="fourth-column">Actions</th>
                  </tr>
                </thead>
                <tbody v-if="institution.institutionEmployerMapping.length > 0">
                  <tr v-for="employerMapping in institution.institutionEmployerMapping">
                    <td class="first-column  text-center" v-if="isSuperAdmin">
                      <label class="form-checkbox">
                        <input type="checkbox" :value="employerMapping.employerId" v-model="selected" :state="deselect" :disabled="(employerMapping.length === 0) || permission.systemPermission.readOnly" aria-label="select config">
                        <i class="form-icon"></i>
                      </label>
                    </td>
                    <td class="second-column text-center">{{employerMapping.employerTitle}}</td>
                    <td class="third-column">{{employerMapping.status}}</td>
                    <td class="third-column">{{ employerMapping.spotlightEmployer ? 'Yes' : 'No' }}</td>
                    <td class="third-column">{{employerMapping.statusUpdatedByName}}</td>
                    <td class="third-column">
                    {{millisToDate(employerMapping.statusUpdatedTime)}}
                    </td>
                    <td class="third-column">
                    {{getJobCount(employerMapping.employerLibraryId)}}
                    </td>
                    
                    <td class="fourth-column">
                        <span class="action-link icon-pencil" @click="edit(employerMapping)" aria-label="edit" tabindex="0" style="cursor: pointer"></span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" class="no-result" style="text-align: center;">No Results Found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        <b-container fluid class="facets-search-grid-container" v-if="editMappingMode">
            <b-row>
                <div class="facets left-container">
                    <div class="main_head">
                        <span class="head_txt">
                        Employers <b> {{numberOfElements}}</b> of 
                            <b> {{Number(totalElements).toLocaleString()}}
                            </b>
                            <span class="btn_container pagination_sty3">
                            <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                            <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                            <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                            </span>

                            <input type="text" class="1input-search" placeholder="search employer" @input="loadEmployerList" aria-label="search user" v-model.trim="searchTitle">
                            <div class="clear-btn" v-if="this.searchTitle.length > 0" @click="loadEmployerList">
                              <b-btn @click="searchTitle = ''" aria-label="clear">X</b-btn>
                            </div>
                        </span>
                        <span class="float-right">
                            <button type="button" class="btn btn-primary" @click="add" aria-label="enroll" :disabled="(employerList.length === 0)">Add</button>
                        </span>
                    </div>
                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <b-form-group aria-label="selected users">
                                    <b-form-checkbox-group plain stacked v-model="selectedEmployers" @input="changeSelectedEmployers" aria-label="Employer list">
                                        <template v-for="employer in employerList">
                                            <b-form-checkbox :value="employer.uuid" :disabled="employer.special" :class="{'special': employer.special}"><span class="check-description">{{ employer.displayName }}</span></b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="facets right-container">

                    <div class="main_head">
                        <span class="head_txt">Current Employers</span>
                        <span class="float-right">
                            <span @click="showDeleteConfirm" :class="{'icon-bin': true, 'action-link': (selectedCurrentEmployer.length > 0)}" :disabled="(selectedCurrentEmployer.length === 0)" aria-label="delete" tabindex="0"></span>
                        </span>
                    </div>
                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <b-form-group aria-label="selected employers">
                                    <b-form-checkbox-group plain stacked v-model="selectedMappedEmployer" @input="selectedCurrentEmployer" aria-label="selected Current Employer">
                                        <template v-for="empMapping in institution.institutionEmployerMapping">
                                            <b-form-checkbox :value="empMapping.employerId" :disabled="empMapping.disabled"><span class="check-description">{{ empMapping.employerTitle }}</span></b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>

            </b-row>
        </b-container>



<!-- Delete Modal -->
          <div>
            <b-modal class="delete-folder-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
              <div style="text-align: center;">
                  <h6>Are you sure you want delete these ({{ selected.length }}) employer mappings?</h6>
              </div>
              <div slot="modal-header" class="header-section">
                <div class="popup-heading">Please Confirm!</div>
                <button class="btn_close" :aria-label="$t('closeAria')" @click="cancelDelete">
                  <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
                <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
              </div>
            </b-modal>
          </div>
<!-- End Delete Modal -->          
<!-- Edit Modal -->
        <div class="modal_popup_container course_unlock_modal">
          <b-modal ref="employerMappingModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="head_txt" style="margin-top: 1px;">Employer Mapping</div>
              <div class="btn_container">
                <button type="button" class="btn_close" @click="closeEmployerMappingModal" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row txt_row">
              <div class="col-6">
                Employer :
              </div>
              <div class="col-6 fld_val">
                <div v-html="employerMappingForEdit.employerTitle"></div>
              </div>
            </div>
            <div class="row txt_row">
              <div class="col-6">
                Status :
              </div>
              <div class="col-6 fld_val">
                <select id="status" v-model="employerMappingForEditStatus" aria-labelledby="Status" style="width: 80%;">
              <option v-for="statusValue in statusArray" :value="statusValue">{{ statusValue }}</option>
            </select>
              </div>
            </div>
            <div class="row txt_row">
              <div class="col-6">
                Spotlight Employer :
              </div>
              <div class="col-6 fld_val">
                <select id="spotlightEmployer" v-model="employerMappingForEditSpotlight" aria-labelledby="Spotlight Employer" style="width: 80%;">
                  <option :value="true">Yes</option>
                  <option :value="false">No</option>
                </select>
              </div>
            </div>
            <div class="row txt_row">
              <div class="col-6">
                Updated By :
              </div>
              <div class="col-6 fld_val">
                <div v-html="employerMappingForEdit.statusUpdatedByName"></div>
              </div>
            </div>
            <div class="row txt_row">
              <div class="col-6">
                Updated At :
              </div>
              <div class="col-6 fld_val">
                <div> {{millisToDate(employerMappingForEdit.statusUpdatedTime)}}</div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12 btn_container" style="text-align: right;">
                <b-button @click="updateEmployerMappingStatus">
                  {{ $tf('update') }}
                </b-button>
                <b-button @click="closeEmployerMappingModal">
                  {{ $tf('cancel') }}
                </b-button>

              </div>
            </div>
          </b-modal>
        </div>
<!-- End Edit Modal -->

        </div>
      </div>

    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
              <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
          </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import Vuelidate from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

export default {
  name: 'institutionEmployerMapping',
  props: ['uuid'],
  components: {
    InstitutionMenu
  },
  data: () => {
    return {
      pageSize: 20,
      sizeOptions: [ 20, 50, 100 ],
      firstPage: true,
      lastPage: false,
      totalPages : 0,
      totalElements:0,
      numberOfElements:0,
      page: 0,
      selected: [],
      selectAll: false,
      showEditModal: false,
      employerMappingForEdit:{},
      employerMappingForEditStatus:'Pending',
      employerMappingForEditSpotlight: false,
      statusArray : ["Approved", "Pending", "Disabled"],
      editMappingMode:false,
      employerList:[],
      selectedEmployers : [],
      selectedMappedEmployer : [],
      selectedCurrentEmployer:[],
      employerJobMap : {},
      searchTitle : '',
      key: null,
      keyState: null,
      dbKey: null,
      apiConfigId: null,
      dirty: false,
      userObject: JSON.parse(localStorage.getItem('userobj')),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION'
    }
  },
  validations: {
    key: {
      required
    }
  },
  watch: {
    key (val) {
      this.dirty = (val !== this.dbKey)
      if (val) {
        this.keyState = null
      }
    }
  },
  mounted () {
      this.$refs.loadingModal.show()
      this.loadEmployerList()
  },
  methods: {
    ...mapActions([
      'searchEmployers',
      'addEmployerMapping',
      'deleteEmployerMapping',
      'loadInstitutionDetail',
      'getInstitutionDetails',
      'getInstitutionInfo',
      'updateEmployerMapping',
      'getAllEmployerJobCount'
    ]),
    async loadEmployerList () {
      this.employerJobMap = await this.getAllEmployerJobCount()
      this.searchEmployers({page: this.page, count: this.pageSize, title: this.searchTitle}).then(result => {
      if(result && result.content){
        this.employerList = result.content
        this.page = result.number
        // latest Spring library changed Page.java fields from firstPage -> first and lastPage -> last
        this.firstPage = (result.first || result.firstPage) ? (result.first || result.firstPage) : false
        this.lastPage = (result.last || result.lastPage) ? (result.last || result.lastPage) : false
        this.totalPages = result.totalPages
        this.totalElements = result.totalElements
        this.numberOfElements = result.numberOfElements
      }
      this.$refs.loadingModal.hide()
      })
    },
    getJobCount(libId){
        return this.employerJobMap && this.employerJobMap[libId]?this.employerJobMap[libId]:0
    },    
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.institution.institutionEmployerMapping) {
          this.selected.push(this.institution.institutionEmployerMapping[i].employerId)
        }
      }
    },
    changeSelectedEmployers () {
/*
      if(this.selectedEmployers){
        this.selectedEmployers.forEach((emp) => {
          emp.isSelected = true
        })
      }
*/      
    },

    millisToDate (millis) {
      if(!millis){
        return 'N/A'
      }
      return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
    },
    async save () {
        this.$refs.loadingModal.show()
        this.addEmployerMapping({institutionId:this.institution.uuid,idsForAdd:this.selectedEmployers}).then(res => {
        this.selectedEmployers = []
        this.institution.institutionEmployerMapping.forEach((mapping) => { 
              if(!mapping.statusUpdatedByUuid){
                mapping.institutionId = this.institution.uuid
                mapping.institutionTitle = this.institution.displayName
                mapping.status = 'Approved'
                mapping.statusUpdatedByUuid = this.userObject.uuid
                mapping.statusUpdatedByName = this.userObject.firstName + ' '+this.userObject.lastName
                mapping.statusUpdatedTime = Date.now()
              }
        })

        this.$refs.loadingModal.hide()
        this.editMappingMode = false
      })
    },

    cancel(){
      let lastMapping = []
      this.institution.institutionEmployerMapping.forEach((mapping) => {
            if(mapping.statusUpdatedByUuid){
              lastMapping.push(mapping)
            }
      })
      this.institution.institutionEmployerMapping = lastMapping
      this.editMappingMode = false
    },
    setEditMappingMode () {
      this.editMappingMode = true
    },

    add () {
      let index = this.institution.institutionEmployerMapping.length
      this.selectedEmployers.forEach((sEmp) => { 
          this.employerList.forEach((emp) => {
            if(emp.uuid===sEmp){  
              let tempEmp = {employerId:emp.uuid, employerTitle:emp.displayName}
              let alreadyAdded = false
              this.institution.institutionEmployerMapping.forEach((mapping) => {
                if(mapping.employerId==tempEmp.employerId){
                    alreadyAdded = true
                }
              })
              if(!alreadyAdded){
                this.institution.institutionEmployerMapping.push(tempEmp)
              }
            }
          })
        })
    },
    edit (mapping) {
      this.$refs.employerMappingModal.show()
      this.employerMappingForEdit = mapping
      this.employerMappingForEditStatus = mapping.status
      this.employerMappingForEditSpotlight = !!mapping.spotlightEmployer
    },
    closeEmployerMappingModal (){
      this.$refs.employerMappingModal.hide()
    },
    updateEmployerMappingStatus(){
        this.updateEmployerMapping({
          institutionId:this.institution.uuid,
          employerId:this.employerMappingForEdit.employerId,
          status:this.employerMappingForEditStatus,
          spotlightEmployer: this.employerMappingForEditSpotlight
        }).then(res => {
          this.employerMappingForEdit.status = this.employerMappingForEditStatus
          this.employerMappingForEdit.spotlightEmployer = this.employerMappingForEditSpotlight
          this.$refs.employerMappingModal.hide()
        })
    },
    showDeleteConfirm (mapping) {
      if (this.selected.length > 0) {
        this.$refs.deleteConfirmModal.show()
      }
    },
    deleteSelected () { 
      this.deleteEmployerMapping({institutionId:this.institution.uuid,idsForDelete:this.selected}).then(res => {

        // Filter the current mapping to remove matching employer IDs
        let currentMapping = this.institution.institutionEmployerMapping
        const updatedMapping = currentMapping.filter(mapping => 
          !this.selected.some(id => id.toLowerCase() === mapping.employerId.toLowerCase())
        );
        this.institution.institutionEmployerMapping = updatedMapping
        this.$refs.deleteConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      })
    },
    cancelDelete () {
      this.$refs.deleteConfirmModal.hide()
      this.selected = []
      this.selectAll = false
    },
    resetPage () {
      this.page = 0
      this.loadEmployerList()
    },
    prev () {
      this.page -= 1
      this.loadEmployerList()
    },
    next () {
      this.page += 1
      this.loadEmployerList()
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'institution': state => state.institution.institution
    }),
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    },
    deselect () {
      if (this.selected.length === this.institution.institutionEmployerMapping.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    }
  }
}
</script>

<style scoped>
  .facets-search-grid-container .left-container {
    flex: 0 0 65%;
    max-width: 65%;
    width: 65%;
  }

  .facets-search-grid-container .right-container {
    flex: 0 0 30%;
    max-width: 30%;
    width: 30%;
    margin-top: 15px;
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionEmployerMapping.vue